import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import LanguageMenu from './language-menu.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import ThemeMenu from './theme-menu.jsx';
import {MenuItem, MenuSection} from '../menu/menu.jsx';

import menuBarStyles from './menu-bar.css';
import styles from './settings-menu.css';

import dropdownCaret from './dropdown-caret.svg';
import settingsIcon from './icon--settings.svg';
import mlIcon from './brain.png';
import trainerConnectIcon from './icon--trainer-connect.png';
import boardsIcon from '../action-menu/icon--file-upload.svg';

const SettingsMenu = ({
    canChangeLanguage,
    canChangeTheme,
    isRtl,
    onOpenHardwareUpload,
    onOpenTrainerDevice,
    onRequestClose,
    onRequestOpen,
    onOpenMLEnvironment,
    settingsMenuOpen
}) => (
    <div
        className={classNames(menuBarStyles.menuBarItem, menuBarStyles.hoverable, menuBarStyles.themeMenu, {
            [menuBarStyles.active]: settingsMenuOpen
        })}
        onMouseUp={onRequestOpen}
    >
        <img
            src={settingsIcon}
        />
        <span className={styles.dropdownLabel}>
            <FormattedMessage
                defaultMessage="Settings"
                description="Settings menu"
                id="gui.menuBar.settings"
            />
        </span>
        <img src={dropdownCaret} />
        <MenuBarMenu
            className={menuBarStyles.menuBarMenu}
            open={settingsMenuOpen}
            place={isRtl ? 'left' : 'right'}
            onRequestClose={onRequestClose}
        >
            <MenuSection>
                {canChangeLanguage && <LanguageMenu onRequestCloseSettings={onRequestClose} />}
                {canChangeTheme && <ThemeMenu onRequestCloseSettings={onRequestClose} />}
            </MenuSection>
            <MenuSection>
                <MenuItem
                    onClick={() => {
                        onRequestClose();
                        if (onOpenHardwareUpload) onOpenHardwareUpload();
                    }}
                >
                    <div className={styles.option}>
                        <img
                            className={styles.icon}
                            src={boardsIcon}
                        />
                        <span className={styles.submenuLabel}>
                            <FormattedMessage
                                defaultMessage="Advanced IoT.Prarambh"
                                description="Menu bar item for selecting hardware boards"
                                id="gui.menuBar.selectBoard"
                            />
                        </span>
                    </div>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onRequestClose();
                        if (onOpenMLEnvironment) onOpenMLEnvironment();
                    }}
                >
                    <div className={styles.option}>
                        <img
                            className={styles.icon}
                            src={mlIcon}
                        />
                        <span className={styles.submenuLabel}>
                            <FormattedMessage
                                defaultMessage="Advanced AI.Prarambh"
                                description="Menu bar item for opening the ML environment"
                                id="gui.menuBar.mlEnvironment"
                            />
                        </span>
                    </div>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onRequestClose();
                        if (onOpenTrainerDevice) onOpenTrainerDevice();
                    }}
                >
                    <div className={styles.option}>
                        <img
                            className={styles.icon}
                            src={trainerConnectIcon}
                        />
                        <span className={styles.submenuLabel}>
                            <FormattedMessage
                                defaultMessage="Connect Trainer Kit"
                                description="Menu bar item for connecting the trainer hardware device"
                                id="gui.menuBar.connectTrainerDevice"
                            />
                        </span>
                    </div>
                </MenuItem>
            </MenuSection>
        </MenuBarMenu>
    </div>
);

SettingsMenu.propTypes = {
    canChangeLanguage: PropTypes.bool,
    canChangeTheme: PropTypes.bool,
    isRtl: PropTypes.bool,
    onOpenHardwareUpload: PropTypes.func,
    onOpenTrainerDevice: PropTypes.func,
    onOpenMLEnvironment: PropTypes.func,
    onRequestClose: PropTypes.func,
    onRequestOpen: PropTypes.func,
    settingsMenuOpen: PropTypes.bool
};

export default SettingsMenu;
